export default () => ({
  invoices: [],
  invoicesTotal: null,
  paymentIntent: null
})
